import { render } from "./listPage.vue?vue&type=template&id=3fc9dfe8"
import script from "./listPage.vue?vue&type=script&lang=js"
export * from "./listPage.vue?vue&type=script&lang=js"

import "./listPage.vue?vue&type=style&index=0&id=3fc9dfe8&lang=css"

import exportComponent from "/Users/yuviony/vspl/ui/vetaconnect_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__